import React from 'react';

import LinkButton from '@atlaskit/button/link';

const LinkButtonDefaultExample = (): React.JSX.Element => {
	return <LinkButton href="https://atlassian.com/">Default Link button</LinkButton>;
};

export default LinkButtonDefaultExample;
